class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (this.getAttribute('data-properties-prescription-id') != '') {
        const allPrescriptions = document.querySelectorAll(
          `tr[data-properties-prescription-id="${this.closest('.cart-item').dataset.propertiesPrescriptionId}"]`
        );

        cartItems.updateQuantityLines(allPrescriptions);
      } else {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    if (!id) return;
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    if (event.target.classList.contains('no-js')) return;

    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    // Дозволяємо 0 одразу видаляти товар
    if (inputValue === 0) {
      this.updateQuantity(index, 0, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
      return;
    }

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(index, inputValue, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
    }
  }


  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          window.customAddToCart.gift_check();
          window.prescriptionModal.init();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;

          window.customAddToCart.gift_check();
          window.prescriptionModal.init();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  async updateQuantityLines(lines) {
    Array.from(lines).forEach((line) => {
      this.enableLoading(line.dataset.index);
    });

    const updates = Object.fromEntries(Array.from(lines).map((line) => [line.dataset.key, 0]));

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      }),
    }).then((response) => {
      if (response.ok) {
        Array.from(lines).forEach((line) => {
          this.disableLoading(line.dataset.index);
        });

        window.customAddToCart.updateDrawerDom();
        window.customAddToCart.gift_check();
        window.prescriptionModal.init();

        return response;
      }
    });
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        window.customAddToCart.gift_check();
        window.prescriptionModal.init();
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);
window.cartItem = new CartItems();

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
class CustomAddToCart {
  constructor() {
    this.drawer = document.querySelector('.cart-drawer');
    this.rate = +Shopify.currency.rate;
    this.country = Shopify.country.toLowerCase();

    this.giftProductID = window.ProductBundlerOptionsConfig.cartGiftProduct;
    this.textCartFreeGiftProductText = window.ProductBundlerOptionsConfig.cartFreeGiftProductText;
    this.giftProductUsPrise = window.ProductBundlerOptionsConfig.cartGiftProductUsPrise;
    this.giftProductInternationalPrise = window.ProductBundlerOptionsConfig.cartGiftProductInternationalPrise;
    this.cartFreeShippingUsSpend = window.ProductBundlerOptionsConfig.cartFreeShippingUsSpend;
    this.cartFreeShippingInternationalSpend = window.ProductBundlerOptionsConfig.cartFreeShippingInternationalSpend;
    this.cartFreeExpressShippingUsSpend = window.ProductBundlerOptionsConfig.cartFreeExpressShippingUsSpend;
    this.expressShippingPrice = this.country === 'us' ? this.cartFreeExpressShippingUsSpend : Infinity;
    this.cartFreeShippingUsSpend = window.ProductBundlerOptionsConfig.cartFreeShippingUsSpend;
    this.cartFreeShippingInternationalSpend = window.ProductBundlerOptionsConfig.cartFreeShippingInternationalSpend;

    this.isUS = this.country === 'us';

    this.cartShippingPrice = this.isUS ? this.cartFreeShippingUsSpend : this.cartFreeShippingInternationalSpend * this.rate;

    this.cartFreeExpressShippingUsSpend = window.ProductBundlerOptionsConfig.cartFreeExpressShippingUsSpend;
    this.expressShippingPrice = this.isUS ? this.cartFreeExpressShippingUsSpend : Infinity;
    this.cartFreeShippingPromoEnable = window.ProductBundlerOptionsConfig.cartFreeShippingPromoEnable;
    this.giftPrice = this.country === 'us' ? this.giftProductUsPrise : this.giftProductInternationalPrise * this.rate;
    this.cartShippingPrice =
        this.country === 'us' ? this.cartFreeShippingUsSpend : this.cartFreeShippingInternationalSpend * this.rate;

    this.cartInit();
  }

  async cartInit() {
    await this.gift_check();
    this.observeCartItems();
  }

  async getCart() {
    try {
      return fetch('/cart.js')
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }

            return response.json();
          })
          .then((cart) => {
            window.cart_drawer_swiper__mobile();
            document.querySelector('.total_items').textContent = `(${cart.item_count})`;

            return cart;
          })
          .catch((error) => {
            console.error('Error fetching cart:', error);
          });
    } catch (error) {
      console.log(error);
    }
  }

  async containsPrescriptionProduct(cart) {
    if (!cart.items.length) return false;

    const nonGiftItems = cart.items.filter((item) => !(item.properties && '_gift_product' in item.properties));

    if (nonGiftItems.length === 0) return false;

    const results = await Promise.all(
        nonGiftItems.map((item) =>
            fetch(`/products/${item.handle}.js`)
                .then((res) => (res.ok ? res.json() : null))
                .then((product) => {
                  if (!product) return false;
                  return product.type?.toLowerCase().includes('prescription');
                })
                .catch(() => false)
        )
    );

    return results.every((result) => result === true);
  }

  async gift_check() {
    const cart = await this.getCart();
    if (!cart) return;

    const hasOnlyPrescription = await this.containsPrescriptionProduct(cart);
    const {total_price} = cart;

    const prescriptionGiftID = window.ProductBundlerOptionsConfig.cartPrescriptionGiftProduct;
    const defaultGiftID = this.giftProductID;

    const prescriptionThreshold = this.country === 'us'
        ? window.ProductBundlerOptionsConfig.cartPrescriptionGiftPriceUS
        : window.ProductBundlerOptionsConfig.cartPrescriptionGiftPriceIntl * this.rate;

    const giftProduct = cart.items.find((item) => item.properties?._gift_product);

    // Якщо в кошику вже є подарунок, але не той, який потрібен — видаляємо
    if (giftProduct) {
      const expectedGiftID =
          hasOnlyPrescription && total_price >= prescriptionThreshold
              ? prescriptionGiftID
              : total_price >= this.giftPrice
                  ? defaultGiftID
                  : null;

      if (expectedGiftID && giftProduct.id !== expectedGiftID) {
        await this.removeGiftProduct(giftProduct.id);
      } else if (!expectedGiftID) {
        await this.removeGiftProduct(giftProduct.id);
      }
    }

    // Додаємо потрібний подарунок
    if (hasOnlyPrescription && total_price >= prescriptionThreshold && prescriptionGiftID) {
      const alreadyHasPrescriptionGift = giftProduct && giftProduct.id === prescriptionGiftID;
      if (!alreadyHasPrescriptionGift) {
        await this.addGiftProduct(prescriptionGiftID);
      }
    } else if (!hasOnlyPrescription && total_price >= this.giftPrice && defaultGiftID) {
      const alreadyHasDefaultGift = giftProduct && giftProduct.id === defaultGiftID;
      if (!alreadyHasDefaultGift) {
        await this.addGiftProduct(defaultGiftID);
      }
    }

    // Якщо не виконані умови для будь-якого подарунка — прибираємо
    const shouldRemoveGift =
        (hasOnlyPrescription && total_price < prescriptionThreshold) ||
        (!hasOnlyPrescription && total_price < this.giftPrice);

    if (shouldRemoveGift && giftProduct) {
      await this.removeGiftProduct(giftProduct.id);
    }

    this.giftLineInit(total_price, hasOnlyPrescription);
  }

  giftLineInit(total_price, hasPrescriptionProduct = false) {
    const header_price = document.querySelector('.content_header');
    const shipping_icon_parent = document.querySelector('.content.free-shipping-us');
    const gift_icon_parent = document.querySelector('.content.gift');
    const express_icon_parent = document.querySelector('.content.express');
    const prescription_icon_parent = document.querySelector('.content.prescription-gift');

    const content_shipping_line = shipping_icon_parent?.querySelector('span');
    const content_gift_line = gift_icon_parent?.querySelector('span');
    const content_express_line = express_icon_parent?.querySelector('span');
    const content_prescription_line = prescription_icon_parent?.querySelector('span');

    const content_body = document.querySelector('.content_body');

    const isUS = this.country === 'us';

    // --- безпечні утиліти для курсів/копійок
    const rate = Number.isFinite(this.rate) && this.rate > 0 ? this.rate : 1;
    const toMinorUnits = (cents) => Math.max(0, Math.round(cents)); // округляємо до центів

    // --- Пороги
    const usShippingThreshold = this.cartFreeShippingUsSpend ?? 0; // у центах базової валюти магазину
    const intlShippingBase = this.cartFreeShippingInternationalSpend ?? usShippingThreshold; // fallback якщо intl не заданий

    // ✔ для не-US: беремо міжнародний поріг і множимо на курс у копійках/центах
    const shippingThreshold = isUS
        ? usShippingThreshold
        : toMinorUnits(intlShippingBase * rate);

    const giftThreshold = this.giftPrice; // залишаю як є (ваша логіка для подарунка)
    const expressThreshold = this.cartFreeExpressShippingUsSpend;

    // рецепт-подарунок: вже був конверт у вас — лише додав акуратне округлення
    const prescriptionThreshold = isUS
        ? (window.ProductBundlerOptionsConfig.cartPrescriptionGiftPriceUS ?? 0)
        : toMinorUnits((window.ProductBundlerOptionsConfig.cartPrescriptionGiftPriceIntl ?? 0) * rate);

    // --- NEW: effective express threshold (used only when we want express to be considered "full" immediately)
    let expressThresholdEffective = expressThreshold;
    if (hasPrescriptionProduct) {
      // ставимо 1 цент, щоб прогрес був 100% і порівняння total_price >= expressThresholdEffective було true
      expressThresholdEffective = 1;
    }

    let currency = '$';
    if (header_price?.dataset.currencyCode) {
      currency = this.splitPrice(header_price.dataset.currencyCode)?.currency || '$';
    }

    const setBar = (el, line, progress) => {
      if (!el || !line) return;
      line.style.width = `${progress}%`;
      if (progress >= 100) el.classList.add('full');
      else el.classList.remove('full');
      el.classList.remove('hide');
      el.style.display = '';
    };

    // Скидаємо все
    [shipping_icon_parent, gift_icon_parent, express_icon_parent, prescription_icon_parent].forEach(el => {
      if (!el) return;
      el.classList.add('hide');
      el.style.display = 'none';
      el.classList.remove('full');
      const span = el.querySelector('span');
      if (span) span.style.width = '0%';
    });
    content_body?.classList.remove('shift');

    const updateShippingFreeBox = () => {
      const shippingFreeBox = document.querySelector('.shipping-free-box');
      const shippingFreeReached = total_price >= shippingThreshold;
      if (shippingFreeBox) {
        if (shippingFreeReached) {
          shippingFreeBox.classList.remove('hide');
          shippingFreeBox.style.display = '';
        } else {
          shippingFreeBox.classList.add('hide');
          shippingFreeBox.style.display = 'none';
        }
      } else {
        console.warn('shipping-free-box не знайдено в DOM');
      }
    };

    const currencySymbols = {
      USD: '$',
      EUR: '€',
      PLN: 'zł',
      GBP: '£',
      SEK: 'kr',
      NOK: 'kr',
      DKK: 'kr',
      CHF: 'CHF',
      CZK: 'Kč',
      HUF: 'Ft'
    };

    const currencyFormat = (value) => {
      const amount = value / 100;
      const formattedAmount = Number.isInteger(amount) ? amount.toString() : amount.toFixed(2);
      const currencyCode = Shopify.currency.active || 'USD'; // отримуємо код валюти з Shopify
      const symbol = currencySymbols[currencyCode] || currencyCode;
      return `${symbol}${formattedAmount}`;
    };

    // computeMessage приймає прапорець forPrescription — щоб використовувати expressThresholdEffective саме у prescription-режимі
    const computeMessage = (forPrescription = false) => {
      const prescriptionReached = total_price >= prescriptionThreshold;
      const shippingReached = total_price >= shippingThreshold;
      const expressUsedThreshold = forPrescription ? expressThresholdEffective : expressThreshold;
      const expressReached = total_price >= expressUsedThreshold;
      const giftReached = total_price >= giftThreshold;

      if (forPrescription) {
        const shippingThresholdForPrescription = isUS ? expressUsedThreshold : shippingThreshold;
        const shippingReachedForPrescription = total_price >= shippingThresholdForPrescription;

        console.log('Prescription message check:', {
          shippingThresholdForPrescription,
          prescriptionThreshold,
          total_price,
          shippingReachedForPrescription,
          prescriptionReached
        });

        if (shippingReachedForPrescription && prescriptionReached) {
          return {
            message: isUS
                ? `You've unlocked FREE EXPRESS SHIPPING and PRESCRIPTION ${this.textCartFreeGiftProductText}!`
                : `You've unlocked FREE SHIPPING and PRESCRIPTION ${this.textCartFreeGiftProductText}!`,
            show: true
          };
        }

        if (!shippingReachedForPrescription && !prescriptionReached) {
          const leftToShipping = Math.max(shippingThresholdForPrescription - total_price, 0);
          const leftToPrescription = Math.max(prescriptionThreshold - total_price, 0);
          return {
            message: `You are ${currencyFormat(leftToShipping)} away from ${isUS ? 'FREE EXPRESS SHIPPING' : 'FREE SHIPPING'} and ${currencyFormat(leftToPrescription)} away from PRESCRIPTION ${this.textCartFreeGiftProductText}`,
            show: true
          };
        }

        if (!shippingReachedForPrescription && prescriptionReached) {
          const leftToShipping = Math.max(shippingThresholdForPrescription - total_price, 0);
          return {
            message: `You are ${currencyFormat(leftToShipping)} away from ${isUS ? 'FREE EXPRESS SHIPPING' : 'FREE SHIPPING'}`,
            show: true
          };
        }

        if (shippingReachedForPrescription && !prescriptionReached) {
          const leftToPrescription = Math.max(prescriptionThreshold - total_price, 0);
          return {
            message: `You are ${currencyFormat(leftToPrescription)} away from PRESCRIPTION ${this.textCartFreeGiftProductText}`,
            show: true
          };
        }

        return { message: '', show: false };
      }

      // non-prescription flow
      if (isUS) {
        if (!(total_price >= shippingThreshold)) {
          const leftToShipping = Math.max(shippingThreshold - total_price, 0);
          return { message: `You are ${currencyFormat(leftToShipping)} away from FREE US SHIPPING`, show: true };
        }
        if (!(total_price >= giftThreshold)) {
          const leftToGift = Math.max(giftThreshold - total_price, 0);
          return { message: `You are ${currencyFormat(leftToGift)} away from ${this.textCartFreeGiftProductText}`, show: true };
        }
        if (!(total_price >= expressThreshold)) {
          const leftToExpress = Math.max(expressThreshold - total_price, 0);
          return { message: `You are ${currencyFormat(leftToExpress)} away from FREE EXPRESS SHIPPING`, show: true };
        }
        return { message: `You've unlocked a ${this.textCartFreeGiftProductText} + FREE EXPRESS SHIPPING!`, show: true };
      } else {
        const giftReachedLocal = total_price >= giftThreshold;
        const shippingReachedLocal = total_price >= shippingThreshold;

        if (giftReachedLocal && shippingReachedLocal) {
          return { message: `You've unlocked FREE SHIPPING and a ${this.textCartFreeGiftProductText}!`, show: true };
        }
        if (!giftReachedLocal && !shippingReachedLocal) {
          const leftToShipping = Math.max(shippingThreshold - total_price, 0);
          return { message: `You are ${currencyFormat(leftToShipping)} away from FREE SHIPPING`, show: true };
        }
        if (!giftReachedLocal && shippingReachedLocal) {
          const leftToGift = Math.max(giftThreshold - total_price, 0);
          return { message: `You are ${currencyFormat(leftToGift)} away from ${this.textCartFreeGiftProductText}`, show: true };
        }
        if (giftReachedLocal && !shippingReachedLocal) {
          const leftToShipping = Math.max(shippingThreshold - total_price, 0);
          return { message: `You are ${currencyFormat(leftToShipping)} away from FREE SHIPPING`, show: true };
        }
        return { message: '', show: false };
      }
    };

    // ----- Progressbars & UI: prescription case -----
    if (hasPrescriptionProduct) {
      const steps = isUS
          ? [[expressThresholdEffective, express_icon_parent, content_express_line], [prescriptionThreshold, prescription_icon_parent, content_prescription_line]]
          : [[shippingThreshold, shipping_icon_parent, content_shipping_line], [prescriptionThreshold, prescription_icon_parent, content_prescription_line]];

      const sequential = steps.every((step, i, arr) => i === 0 || step[0] > arr[i - 1][0]);
      if (sequential) {
        for (let i = 0; i < steps.length; i++) {
          const [threshold, el, line] = steps[i];
          if (!threshold || !el) continue;
          const progress = Math.min((total_price / threshold) * 100, 100);
          const prevFull = i === 0 || steps[i - 1][1]?.classList.contains('full');
          setBar(el, line, prevFull ? progress : 0);
        }
      } else {
        for (const [threshold, el, line] of steps) {
          if (!threshold || !el) continue;
          const progress = Math.min((total_price / threshold) * 100, 100);
          setBar(el, line, progress);
        }
      }

      updateShippingFreeBox();

      // Показати повідомлення для prescription (computeMessage(true) використовує expressThresholdEffective)
      const { message, show } = computeMessage(true);
      const messageBox = document.querySelector('.content_success_message');
      if (messageBox) {
        messageBox.style.display = show ? 'block' : 'none';
        messageBox.textContent = message;
        if (show) header_price?.classList.add('show');
      }
      return;
    }

    // ----- Progressbars & UI: non-US case -----
    if (!isUS) {
      const steps = [
        [shippingThreshold, shipping_icon_parent, content_shipping_line],
        [giftThreshold, gift_icon_parent, content_gift_line]
      ];

      const sequential = steps.every((step, i, arr) => i === 0 || step[0] > arr[i - 1][0]);
      if (sequential) {
        for (let i = 0; i < steps.length; i++) {
          const [threshold, el, line] = steps[i];
          if (!threshold || !el) continue;
          const progress = Math.min((total_price / threshold) * 100, 100);
          const prevFull = i === 0 || steps[i - 1][1]?.classList.contains('full');
          setBar(el, line, prevFull ? progress : 0);
        }
      } else {
        for (const [threshold, el, line] of steps) {
          if (!threshold || !el) continue;
          const progress = Math.min((total_price / threshold) * 100, 100);
          setBar(el, line, progress);
        }
      }

      updateShippingFreeBox();

      const { message, show } = computeMessage(false);
      const messageBox = document.querySelector('.content_success_message');
      if (messageBox) {
        messageBox.style.display = show ? 'block' : 'none';
        messageBox.textContent = message;
        if (show) header_price?.classList.add('show');
      }
      return;
    }

    // ----- Progressbars & UI: US sequential flow (без prescription) -----
    if (total_price < shippingThreshold) {
      if (shipping_icon_parent) { shipping_icon_parent.classList.remove('hide'); shipping_icon_parent.style.display = ''; }
      if (gift_icon_parent) { gift_icon_parent.classList.remove('hide'); gift_icon_parent.style.display = ''; }
      if (express_icon_parent) { express_icon_parent.classList.add('hide'); express_icon_parent.style.display = 'none'; }

      const progressShipping = Math.min((total_price / shippingThreshold) * 100, 100);
      setBar(shipping_icon_parent, content_shipping_line, progressShipping);
      setBar(gift_icon_parent, content_gift_line, 0);
    } else if (total_price < giftThreshold) {
      if (shipping_icon_parent) { shipping_icon_parent.classList.add('hide'); shipping_icon_parent.style.display = 'none'; }
      if (gift_icon_parent) { gift_icon_parent.classList.remove('hide'); gift_icon_parent.style.display = ''; }
      if (express_icon_parent) { express_icon_parent.classList.remove('hide'); express_icon_parent.style.display = ''; }

      const progressGift = Math.min((total_price / giftThreshold) * 100, 100);
      setBar(gift_icon_parent, content_gift_line, progressGift);
      setBar(express_icon_parent, content_express_line, 0);
    } else {
      if (shipping_icon_parent) { shipping_icon_parent.classList.add('hide'); shipping_icon_parent.style.display = 'none'; }
      if (gift_icon_parent) { gift_icon_parent.classList.remove('hide'); gift_icon_parent.style.display = ''; }
      if (express_icon_parent) { express_icon_parent.classList.remove('hide'); express_icon_parent.style.display = ''; }

      const progressGift = Math.min((total_price / giftThreshold) * 100, 100);
      setBar(gift_icon_parent, content_gift_line, progressGift);
      const progressExpress = Math.min((total_price / expressThreshold) * 100, 100);
      setBar(express_icon_parent, content_express_line, progressExpress);
    }

    updateShippingFreeBox();
    const { message, show } = computeMessage(false);
    const messageBox = document.querySelector('.content_success_message');
    if (messageBox) {
      messageBox.style.display = show ? 'block' : 'none';
      messageBox.textContent = message;
      if (show) header_price?.classList.add('show');
    }
  }


  async addGiftProduct(productID) {
    if (!productID) return;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: productID,
          quantity: 1,
          properties: { _gift_product: true },
        }),
      }).then((response) => {
        if (response.ok) {
          this.updateDrawerDom();
        }
      });
    } catch (error) {
      console.log('%c error ', 'color: #fff; font-size: 12px; background: red;', error);
    }
  }

  async removeGiftProduct(productID) {
    if (!productID) return;

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: {
            [productID]: 0,
          },
        }),
      }).then((response) => {
        if (response.ok) {
          this.updateDrawerDom();
        }
      });
    } catch (error) {
      console.log('%c error ', 'color: #fff; font-size: 12px; background: red;', error);
    }
  }

  splitPrice(priceString) {
    const match = priceString.match(/([\D]+)(\d+)[.,](\d+)/);
    if (!match) return null;

    const currency = match[1].trim();
    const amountInCents = parseInt(match[2] + match[3]);

    return { currency, amountInCents };
  }

  splitStringPrice(price) {
    if (price.includes('.')) return price.split('.').join('');
    if (price.includes(',')) return price.split(',').join('');
  }
  async updateDrawerDom() {
    try {
      const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const res_new = await response.json();

      if (!res_new) return;

      setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        cartDrawer.renderContents({ sections: res_new });
        this.moveGiftToFirstPosition();
        this.gift_check();
        window.prescriptionModal.init();
      }, 20);
    } catch (error) {
      console.error('Помилка при fetch кошика:', error);
    }
  }

  moveGiftToFirstPosition() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const cartItemsContainer = cartDrawer.querySelector('.cart-items') || cartDrawer;
    const cartItems = cartItemsContainer.querySelectorAll('.cart-item');

    if (cartItems.length === 0) {
      cartDrawer.classList.add('is-empty');
      return;
    }

    cartDrawer.classList.remove('is-empty');

    const giftItem = Array.from(cartItems).find(item =>
        item.dataset.giftProduct === "true" ||
        (item.querySelector('[name="properties[_gift_product]"]')?.value === "true")
    );

    if (giftItem && cartItemsContainer.firstElementChild !== giftItem) {
      giftItem.style.transition = 'all 0.3s ease';
      giftItem.classList.add('moving-gift-item');

      cartItemsContainer.prepend(giftItem);

      setTimeout(() => {
        giftItem.style.transition = '';
        giftItem.classList.remove('moving-gift-item');
      }, 300);
    }
  }

  observeCartItems() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const cartItemsContainer = cartDrawer.querySelector('.cart-items') || cartDrawer;

    const observer = new MutationObserver(() => {
      this.moveGiftToFirstPosition();
    });

    observer.observe(cartItemsContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-gift-product']
    });

    document.addEventListener('cart:updated', () => this.moveGiftToFirstPosition());
    window.addEventListener('load', () => this.moveGiftToFirstPosition());
  }
}
window.customAddToCart = new CustomAddToCart();

class PrescriptionModal {
  constructor() {
    this.init();
  }

  init() {
    this.prescriptionModals = document.querySelectorAll('.prescription-modal');
    this.prescriptionElements = document.querySelectorAll('.prescription-modal .prescription-elements');
    this.prescriptionElementsEdit = document.querySelectorAll('.prescription-modal .prescription-elements-edit');

    this.body = document.querySelector('body');
    this.openTrigers = document.querySelectorAll('cart-drawer-items .prescription-modal .open_btn');
    this.closeTrigers = document.querySelectorAll('cart-drawer-items .prescription-modal .close-btn');
    this.editTrigers = document.querySelectorAll('cart-drawer-items .btns-box .btn-edit');
    this.saveTrigers = document.querySelectorAll('cart-drawer-items .btns-box .btn-save');
    this.backTrigers = document.querySelectorAll('cart-drawer-items .btns-box .btn-back');

    this.readPrescriptionItems();
    this.initTriggers();
    this.openModal();
    this.editPrescription();
    this.closeModal();

    this.saveNewPrescription();

    this.backTrigers.forEach((triger) => {
      triger.addEventListener('click', (evt) => {
        evt.preventDefault();

        this.resetModals();
      });
    });
  }

  async saveNewPrescription() {
    this.saveTrigers.forEach((triger, index) => {
      triger.addEventListener('click', async (evt) => {
        evt.preventDefault();
        const target = evt.target;

        const parent = target.closest('.cart-item');
        const parentRemoveBtn = parent.querySelector('cart-remove-button');
        const removeElements = document.querySelectorAll(
          `.cart-item[data-properties-prescription-id="${parentRemoveBtn.dataset.propertiesPrescriptionId}"]`
        );
        const uniqID = +parentRemoveBtn.dataset.propertiesPrescriptionId;

        const { items } = await window.customAddToCart.getCart();

        const productsOld = items.filter((item) => item.properties._uniqueId === uniqID);

        const newPrescriptionItems = this.prescriptionElementsEdit[index].querySelectorAll('select');
        const newDataProperties = {};

				newPrescriptionItems.forEach((select) => {
					const key = select.dataset.id.toUpperCase();

					if (select.value !== '-') {
						newDataProperties[key] = select.value;
					}

					if (select.value === '0.00') {
						newDataProperties[key] = null;
					}
				});


        const data = [];

        const cartItems = target.closest('cart-items') || target.closest('cart-drawer-items');

        productsOld.forEach((product) => {
          if (product.properties._main_product) {
            Object.keys(newDataProperties).forEach((key) => {
              if (key in product.properties) {
                product.properties[key] = newDataProperties[key];
              }
            });
          }

          data.push({
            id: product.id,
            ['variant_id']: product.variant_id,
            properties: { ...product.properties },
            quantity: 1,
          });
        });

        await cartItems.updateQuantityLines(removeElements).then((response) => {
          if (response.ok) {
            setTimeout(() => {
              fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  items: data,
                  sections: ['cart-icon-bubble', 'cart-drawer'],
                }),
              }).then((res) => {
                if (res.ok) {
                  setTimeout(() => {
                    window.customAddToCart.gift_check();
                    window.customAddToCart.updateDrawerDom();
                  }, 10);
                }
              });
            }, 500);
          }
        });
      });
    });
  }

  readPrescriptionItems() {
    const change = new Event('change');

    this.prescriptionElements.forEach((prscription, index) => {
      const selectedElements = prscription.querySelectorAll('.prescription-field');

      selectedElements.forEach((field) => {
        if (field.dataset.name) {
          const editSelects = this.prescriptionElementsEdit[index].querySelectorAll('select');
          editSelects.forEach((select) => {
            if (field.dataset.name === select.dataset.id || field.dataset.name.toLowerCase().includes(select.dataset.id.toLowerCase())) {
              select.value = field.dataset.value;
              select.dispatchEvent(change);
            }
          });
        }
      });
    });
  }

  initTriggers() {
    this.openTrigers.forEach((triger) => (triger.disabled = false));
    this.editTrigers.forEach((triger) => (triger.disabled = false));
  }

  editPrescription() {
    this.editTrigers.forEach((triger, index) => {
      triger.addEventListener('click', (evt) => {
        evt.preventDefault();

        triger.classList.add('hide');
        this.prescriptionElements[index].classList.add('hide');
        this.saveTrigers[index].classList.remove('hide');
        this.backTrigers[index].classList.remove('hide');
        this.prescriptionElementsEdit[index].classList.remove('hide');

        this.readPrescriptionItems();
      });
    });
  }

  closeModal() {
    this.closeTrigers.forEach((closeTriger) => {
      closeTriger.addEventListener('click', () => this.resetModals());
    });
  }

  openModal() {
    this.openTrigers.forEach((openTriger, index) => {
      openTriger.addEventListener('click', (evt) => {
        evt.preventDefault();

        this.initModal(this.prescriptionModals[index]);
      });
    });
  }

  initModal(prescription) {
    const modal = prescription.querySelector('.modal');
    const closeBtn = prescription.querySelector('.close-btn');

    modal.showModal();

    window.addEventListener('keydown', (evt) => {
      if (evt.code === 'Escape') this.resetModals();
    });

    closeBtn.addEventListener('click', (evt) => {
      evt.preventDefault();

      this.body.classList.remove('lock');
      this.resetModals();
      modal.close();
    });

    modal.addEventListener('click', (evt) => {
      const modal = evt.currentTarget;
      const isClickOnBoard = evt.target === modal;

      if (isClickOnBoard) {
        this.body.classList.remove('lock');
        this.resetModals();
        modal.close();
      }
    });
  }

  resetModals() {
    this.prescriptionElements.forEach((element) => element.classList.remove('hide'));
    this.prescriptionElementsEdit.forEach((element) => element.classList.add('hide'));
    this.editTrigers.forEach((element) => element.classList.remove('hide'));
    this.saveTrigers.forEach((element) => element.classList.add('hide'));
    this.backTrigers.forEach((element) => element.classList.add('hide'));
  }
}

window.prescriptionModal = new PrescriptionModal();
